import React, { forwardRef, useRef } from "react";
import { RCCDropzone } from "react-common-components";
import IComponentDropzone, { IRefDropzone } from "react-common-components/dist/components/Dropzone/interface";
import { useTranslation } from "src/context/Translations/context";

const Attachments: React.ForwardRefRenderFunction<IRefDropzone, Omit<IComponentDropzone, "label" | "labelAttachment" | "maxSize">> = ({
	...rest
}, ref) => {
	const localRef = useRef<IRefDropzone>(null);
	const internalRef = ref ?? localRef;

	const { translate } = useTranslation();
	return (
		<RCCDropzone 
			ref={internalRef}
			label={translate("Arraste e solte alguns arquivos aqui ou clique para selecionar arquivos")}
			labelAttachment={translate("Anexos")}
			tooltipDelete={translate("Deletar")}
			tooltipDownload={translate("Baixar")}
			maxSize={20000000}
			{ ...rest}
		/>
	);
};

export default forwardRef(Attachments);
